import { render } from "./Job_placement.vue?vue&type=template&id=0ab3f4b2&ts=true"
import script from "./Job_placement.vue?vue&type=script&lang=ts"
export * from "./Job_placement.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__